import React, { useState } from 'react';
import './App.css';
import {UserProvider} from "./context/UserContext";
import {ProjectsProvider} from "./context/ProjectsContext";
import {BillingProvider} from "./context/BillingContext";
import {AuthUIProvider} from "./context/AuthUIContext";
import { BrowserRouter as Router} from 'react-router-dom';
import NavigationComponent from "./navigation/NavigationComponent";
import {SplitPanelProvider} from "./context/SplitPanelContext";
import {ThemeProvider} from "./context/ThemeContext";

function App() {
  const [showSignIn, setShowSignIn] = useState(false);

  return (
      <Router>
          <ThemeProvider>
          <UserProvider>
              <ProjectsProvider>
                  <BillingProvider>
                      {/*
                        Just opens the modal. Where to land afterwards is decided by
                        LocalingosAuthenticator, which is the only thing that knows
                        whether the visitor ended up registering or signing in —
                        they can switch tabs after the modal opens.
                      */}
                      <AuthUIProvider openSignIn={() => setShowSignIn(true)}>
                          <SplitPanelProvider>
                              <NavigationComponent showSignIn={showSignIn}
                                                   setShowSignIn={setShowSignIn}/>
                          </SplitPanelProvider>
                      </AuthUIProvider>
                  </BillingProvider>
              </ProjectsProvider>
          </UserProvider>
          </ThemeProvider>
      </Router>
  );
}

export default App;
